import React, { useContext, useState, useEffect, useRef } from 'react';

const RoomStatusProgress = ({ item, isFinalStep, status, index, total }) => {

	const getLeftPosition = (itemIndex) => {
		let leftPosition = 0;
		if (status) {
			let perc = (itemIndex * 100 / total) + "%";
			leftPosition = isFinalStep ? `calc(${perc} - 30px)` : `calc(${perc} - 23px)`;

			if (!itemIndex) {
				leftPosition = isFinalStep ? "-27px" : "-17px";
			}
		}
		//console.log(leftPosition)
		return leftPosition;
	}

	const getTransitionDelay = (index) => {
		if (status) {
			return `${0.3 + (0.1 * index)}s`;
		} else {
			return "0s"
		}
	}

	return (
		<>
			<div className="w-100 text-center">
				{!isFinalStep ?
					<>
						<div className="d-flex align-items-center justify-content-between mb-2">
							<h5 className={`user-item-name fs-7 text-center`}>
								{item.nickName || item.displayName}
							</h5>
							<div>
								{item.itemIndex != null && (
									<span className="badge rounded-pill bg-info fw-normal me-2">
										{item.itemIndex}
									</span>
								)}
								{/*{item.maxItemIndex != null && (*/}
								{/*	<span className="badge rounded-pill bg-warning fw-normal">*/}
								{/*		{item.maxItemIndex}*/}
								{/*	</span>*/}
								{/*)}*/}
							</div>
						</div>
						<div className="user-item-avatar" style={{ transitionDelay: getTransitionDelay(index) }}>
							<img src={`/img/react-app/avatars/01/avatar-${item.avatarId}.png`} title={item.nickName || item.displayName} className="user-avatar" />
							<span className="badge rounded-pill bg-info fw-normal">
								{item.itemIndex}
							</span>
						</div>
						<div className="user-item-progress">
							<div className="user-item-progress-fragment user-item-progress-actual" style={{ width: `${(item.itemIndex * 100 / total)}%` }}></div>
							<div className="user-item-progress-fragment user-item-progress-done" style={{ width: `${(item.maxItemIndex * 100 / total)}%` }}></div>
						</div>
					</>
					:
					<>
						<div className="d-flex align-items-top justify-content-between room-status-progress">
							{/*{item.totalScore ? (*/}
							{/*	<div className={`user-item-score d-flex flex-column align-items-center justify-content-center me-3 me-xl-5 p-3 bg-${item.isCompleted ? "success" : "warning"} text-white`}>*/}
							{/*		<span className={`lh-sm`}>{item.totalScore}</span>*/}
							{/*		<small className="d-block fw-light fs-8 fs-lg-6 mt-n2">PUNTI</small>*/}
							{/*	</div>*/}
							{/*) : ""}*/} 
							<h5 className={`user-item-name fw-bold d-flex w-100 align-items-center mb-0 text-uppercase fs-lg-5`}>
								<img src={`/img/react-app/avatars/01/avatar-${item.avatarId}.png`} title={item.nickName || item.displayName} className="user-avatar" />
								{item.nickName || item.displayName}
							</h5>
						</div>
						<div className="d-flex align-items-center mt-3">
							<div className="d-flex justify-content-center me-3 me-sm-4 user-item-badges">
								{item.itemIndex != null && (
									<span className="badge rounded-pill bg-info fw-normal me-2">
										{item.itemIndex}
									</span>
								)}
								{/*{item.maxItemIndex != null && (*/}
								{/*	<span className="badge rounded-pill bg-warning fw-normal">*/}
								{/*		{item.maxItemIndex}*/}
								{/*	</span>*/}
								{/*)}*/}
							</div>
							<div className="user-item-progress m-0">
								<div className="user-item-progress-fragment user-item-progress-actual" style={{ width: `${(item.itemIndex * 100 / total)}%` }}></div>
								<div className="user-item-progress-fragment user-item-progress-done" style={{ width: `${(item.maxItemIndex * 100 / total)}%` }}></div>
							</div>
						</div>
						
					</>
				}
			</div>
		</>
	)
}

export default RoomStatusProgress;
